import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import "@/assets/style/reset.css";
import router from "./router";
import store from "./store";
import installMaxerStore, {Maxer} from './store/maxer.mixin';
// import initStorePersistence from './store/store.persistence';
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import '@/assets/icon/iconfont.css';
import locale from "element-plus/lib/locale/lang/zh-cn";
import $axios from './service';
import apis from './service/api';
import commonMethods from './common/commonMethods';
import "../public/UE/jquery.min.js";
import "../public/UE/ueditor.config";
import "../public/UE/ueditor.all";
import "../public/UE/plugins/135editor";
import "../public/UE/lang/zh-cn/zh-cn";
// import VueAxios from 'vue-axios';
// 声明全局组件 防止需要this调用时不能识别类型
declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $m: Maxer  // 声明全局方法
    }
}
const app = createApp(App);
installMaxerStore(app); // 全局混入vuex
// initStorePersistence(store); // 初始化持久化vuex
app.config.globalProperties.$axios = $axios;
app.config.globalProperties.$getApis = apis.getApis;
app.config.globalProperties.$postApis = apis.postApis;
app.config.globalProperties.$cm = commonMethods;
app.config.globalProperties.$qs = require('qs');
// app.use(store).use(router).use(VueAxios, $axios).use(ElementPlus).mount("#app");
app.use(store).use(router).use(ElementPlus, {locale}).mount("#app");
// console.log('app', app);